<div class="row-custom">

  <div class="menu-left">

    <form #ngForm="ngForm" id="ngForm" (ngSubmit)="onSubmit(ngForm)" >
      <div class="col-custom">

        <div class="form-group">
          <label for="drp">{{'CONFIGURATION_DONNEES.TYPE' | translate}}</label>
          <ng-select [items]="tabTypeGraph"
            bindLabel="nom"
            bindValue="valeur"
            [multiple]="false"
            [closeOnSelect]="true"
            placeholder="{{'GLOBAL.SELECT_TYPE_GRAPHIQUE' | translate}}"
            name="selectType"
            id="selectType"
            [(ngModel)]="chartType"
            [searchable]="false"
            (change)="onChangeTypeChart()"
            class="custom"
            [clearable]="false"
            [ngClass]="{'error-value': chartType == '' && showError}"
            required
          ></ng-select>
        </div>

        <div class="form-group">
          <label for="drp">{{'CONFIGURATION_DONNEES.ZONE' | translate}}</label>
          <ng-select [items]="tabZones"
            bindLabel="nom"
            [multiple]="false"
            [closeOnSelect]="true"
            placeholder="{{'GLOBAL.ZONE' | translate}}"
            name="selectZone"
            id="selectZone"
            [(ngModel)]="zoneSelectionnee"
            (change)="onChangeZone()"
            [clearable]="true"
          ></ng-select>
        </div>

        <div class="form-group">
          <label for="drp">{{'GLOBAL.PERIODE' | translate}}</label>
          <div class="input-group">
            <mat-date-range-input [rangePicker]="kpisRangePicker" [ngClass]="{'error-value': periodeSelectionnee == undefined && showError}">
              <input matStartDate placeholder="{{'GLOBAL.SELECT_PERIODE_GRAPHIQUE' | translate}}"
                [(ngModel)]="rangeStart" name="drpStart" readonly
                (dateChange)="onDateRangeChanged()" (click)="kpisRangePicker.open()" (focus)="kpisRangePicker.open()">
              <input matEndDate placeholder="{{'GLOBAL.SELECT_PERIODE_GRAPHIQUE' | translate}}"
                [(ngModel)]="rangeEnd" name="drpEnd" readonly
                (dateChange)="onDateRangeChanged()" (click)="kpisRangePicker.open()" (focus)="kpisRangePicker.open()">
            </mat-date-range-input>
            <mat-date-range-picker #kpisRangePicker></mat-date-range-picker>
            </div>
          </div>

          <div class="form-group">
            <label for="drp">{{'GLOBAL.PERIODE_PREDEFINIE' | translate}}</label>
            <ng-select [items]="tabPeriodes"
              [multiple]="false"
              [closeOnSelect]="true"
              bindLabel="nom"
              bindValue="valeur"
              placeholder="{{'GLOBAL.PERIODE_PREDEFINIE' | translate}}"
              name="selectPeriode"
              id="selectPeriode"
              [(ngModel)]="periodeSelectionnee"
              (change)="onChangePeriode()"
              [clearable]="false"
              [ngClass]="{'error-value': periodeSelectionnee == undefined && showError}"
              autocomplete="off"
            ></ng-select>
          </div>

          <div class="form-group">
            <label for="selectEchelleX">{{'GLOBAL.ECHELLE_ABSCISSE' | translate}}</label>
            <ng-select [items]="tabEchelle"
              [multiple]="false"
              [closeOnSelect]="true"
              placeholder="Echelle en X"
              name="selectEchelleX"
              id="selectEchelleX"
              bindLabel="nom"
              bindValue="valeur"
              [(ngModel)]="echelleX"
              (change)="onchangeEchelleX()"
              [clearable]="false"
            ></ng-select>
          </div>

          <div class="form-group">
            <label for="selectTypeTir">{{'GLOBAL.TYPES_TIR' | translate}}</label>
            <ng-select [items]="tabTypesTir"
              [multiple]="true"
              [closeOnSelect]="true"
              bindLabel="nom"
              placeholder=""
              name="selectTypeTir"
              id="selectTypeTir"
              [(ngModel)]="typeTirSelectionnees"
              (change)="onChangetypeTir()"
              [clearable]="true"
            ></ng-select>
          </div>

          <div class="form-group">
            <label for="selectData">{{'MODALE_DONNEE_ANALYSE.DONNEE_ANALYSE' | translate}}</label>
            <ng-select [items]="tabRefDonneeAnalyse"
              [multiple]="true"
              [maxSelectedItems]="2"
              [closeOnSelect]="true"
              [searchable]="true"
              bindLabel="referentielDonneeAnalyse.nom"
              placeholder="{{'MODALE_DONNEE_ANALYSE.DONNEE_ANALYSE' | translate}}"
              name="selectData"
              id="selectData"
              [(ngModel)]="dataSelectionnee"
              class="custom"
              [clearable]="true"
              [loading]="loading"

              [ngClass]="{'error-value': dataSelectionnee.length < 1 && showError}"
              (remove)="onRemoveDonneeAnalyse($event)"
              required
              ></ng-select
              >
              @if (selections.length >= 2) {
                <div class="">
                  <small>{{'GLOBAL.LIMITE_GRAPHIQUE' | translate}}</small>
                </div>
              }
            </div>

            <div class="form-group">
              <label for="selectProb">{{'DONNEE_SUIVI_OP.PROBLEMES' | translate}}</label>
              <ng-select [items]="tabProblemes"
                [multiple]="true"
                [closeOnSelect]="true"
                [searchable]="true"
                bindLabel="nom"
                placeholder="{{'DONNEE_SUIVI_OP.PROBLEMES' | translate}}"
                name="selectProb"
                id="selectProb"
                [(ngModel)]="problemeSelectionne"
                class="custom"
                [clearable]="false"
                [loading]="loading"
                [isOpen]="selections.length >= 2 ? false : null"
                [disabled]="chartType == 'Box plot' || chartType == 'combine'"
                [disabled]="true"
              ></ng-select>
            </div>
          </div>

        </form>

        <div class="btn-box">
          <div class="floating-action-button" (click)="clearAll()" >
            <i class="fas fa-redo-alt"></i>
          </div>
          <div class="floating-action-button" [ngClass]="{'no-active' : !saveActive}" (click)="openModalNomGraph()" >
            <i class="fas fa-save"></i>
          </div>
          <button  form="ngForm" type="submit" class="floating-action-button" >
            <i class="fas fa-play"></i>
          </button>
        </div>

      </div>

      @if (showIcon) {
        <div class="chart-box-icon">
          <i class="fas fa-chart-line"></i>
        </div>
      }

      @if (!showIcon) {
        <div  class="chart-box">
          <ngx-loading [config]="{ fullScreenBackdrop: true, backdropBackgroundColour:'transparent' }" [show]="dataLoading"></ngx-loading>
          @if (chartType == 'Ligne' && lineChartData) {
            <canvas #lineChart class="chart"></canvas>
          }
          @if (chartType == 'Box plot' && boxPlotData) {
            <canvas #boxPlotChart class="chart"></canvas>
          }
          @if (combinedChartData) {
            <div class="combined-chart-container">
              <table class="combined-chart table-sm">
                <thead style="font-size:.7em">
                  <tr>
                    <th class="first-th"></th>
                    @for (d of combinedChartData.datesDeTirs; track d) {
                      <th scope="col">{{d | date: 'dd/MM/yyyy'}}</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (d of combinedChartData.lignes; track d) {
                    <tr [ngClass]="{'fond-bleu' : d.nomZone}">
                      @if (d.nomZone) {
                        <td class="td-zone">{{d.nomZone}}</td>
                        <td colspan="100%"></td>
                      }
                      @if (d.nomProjet) {
                        <td class="first-column" scope="row">{{d.nomProjet}}</td>
                        @for (data of d.datas; track data) {
                          <td [ngStyle]="{'background-color': data.couleur}">{{data.val}}</td>
                        }
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }

    </div>

    <div bsModal #modalNomGraph="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <form (ngSubmit)="save($event)">
              <div class="form-group">
                <label for="nomGraph">{{'GLOBAL.NOM_GRAPHIQUE' | translate}}</label>
                <input type="text" class="form-control" name="nomGraph" id="nomGraph" maxlength="50" />
              </div>
              <div class="btn-toolbar justify-content-between">
                <div class="btn-group" role="group">
                  <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
                </div>
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-secondary" (click)="modalNomGraph.hide()">{{'GLOBAL.ANNULER' | translate}}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div bsModal #modalDejaAjoute="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop:'static'}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center">
            <p>{{'GLOBAL.GRAPHIQUE_DEJA_AJOUTE' | translate}}</p>
            <button type="button" class="btn btn-primary" (click)="modalDejaAjoute.hide()">{{'GLOBAL.OK' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
